<template>
  <section class="alunos" :class="{ mostrar: storeEditar.mostrarConteudo }">
    <div class="opcoes">
      <LateralCursos v-if="storeCursos.curso && !storeModulos.modulo" />
      <LateralModulos v-if="storeCursos.curso && storeModulos.modulo" />
    </div>
    <div class="conteudo">
      <!-- Informações -->
      <div class="parte">
        <div class="carregando" :class="{ mostrar: state.loading }">
          <span></span>
        </div>
        <ListaCursos v-if="!storeCursos.curso?._id && !storeModulos.modulo?._id" />
        <ListaModulos v-if="storeCursos.curso?._id && !storeModulos.modulo?._id" />
        <ListaAulas v-if="storeCursos.curso?._id && storeModulos.modulo?._id" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, reactive, inject, watch } from 'vue'
import { useStoreEditar, useStoreCursos, useStoreAreas, useStoreModulos, useStoreAulas } from '@stores'
import ListaCursos from './ListaCursos.vue'
import ListaModulos from './ListaModulos.vue'
import ListaAulas from './ListaAulas.vue'
import LateralCursos from './LateralCursos.vue'
import LateralModulos from './LateralModulos.vue'

const storeAreas = useStoreAreas()
const storeEditar = useStoreEditar()
const storeCursos = useStoreCursos()
const storeModulos = useStoreModulos()
const storeAulas = useStoreAulas()
const emitter = inject('emitter')

const state = reactive({
  loading: false
})

async function receberCursos() {
  state.loading = true
  storeModulos.modulo = null
  const idArea = storeAreas.area?._id
  await storeCursos.receberTodos(idArea)
  state.loading = false
}

async function receberModulos() {
  state.loading = true
  const idArea = storeAreas.area?._id
  const idCurso = storeCursos.curso?._id
  await storeModulos.receberTodos(idArea, idCurso)
  state.loading = false
}

async function receberAulas() {
  state.loading = true
  const idArea = storeAreas.area?._id
  const idCurso = storeCursos.curso?._id
  const idModulo = storeModulos.modulo?._id
  await storeAulas.receberTodos(idArea, idCurso, idModulo)
  state.loading = false
}

function iniciarLoading() {
  state.loading = true
}

function pararLoading() {
  state.loading = false
}

watch(
  () => storeAreas.area?._id,
  (idArea) => {
    if (idArea) {
      receberCursos()
    }
  },
  { immediate: true }
)

onMounted(() => {
  emitter.on('iniciarCarregamento', iniciarLoading)
  emitter.on('pararCarregamento', pararLoading)
  emitter.on('atualizarCursos', receberCursos)
  emitter.on('atualizarModulos', receberModulos)
  emitter.on('atualizarAulas', receberAulas)
})
</script>

<style scoped>
section.alunos {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  position: fixed;
  top: -100dvh;
  left: 0;
  width: 100%;
  height: calc(100dvh - 50px);
  background-color: var(--cor-escuro-1);
  overflow-y: scroll;
  scrollbar-width: none;
  z-index: 5;
  transition: all 0.8s;
}
section.alunos::-webkit-scrollbar {
  display: none;
}
section.alunos.mostrar {
  top: 60px;
}
section.alunos.mostrar .opcoes {
  left: 0;
}
.opcoes {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: fixed;
  background-color: var(--cor-escuro-2);
  border-right: 2px solid var(--cor-escuro-3);
  top: 50px;
  left: -320px;
  width: 320px;
  height: 100%;
  transition: all 0.5s;
}
.opcoes .lista {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px 15px 80px 15px;
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  scrollbar-width: none;
}
.opcoes .lista::-webkit-scrollbar {
  display: none;
}
.opcoes .topo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15px;
  width: 100%;
  border-bottom: 1px solid var(--cor-escuro-3);
}
.opcoes .topo .campo {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}
.opcoes .topo .campo svg {
  position: absolute;
  left: 15px;
  width: 12px;
  min-width: 12px;
  fill: var(--cor-escuro-6);
}
.opcoes .topo .campo input {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: var(--cor-escuro-3);
  width: 100%;
  border-radius: 10px;
  padding: 10px 10px 10px 35px;
  transition: all 0.3s;
}
.opcoes .topo .campo input:focus {
  background-color: var(--cor-escuro-4);
}
.opcoes .topo .campo input::placeholder {
  color: var(--cor-escuro-6);
}
.opcoes .topo h3 {
  font-family: var(--medium);
  font-size: var(--f1);
  color: var(--cor-branco);
  margin: 0 0 10px 0;
}
.opcoes button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 15px 12px;
  background-color: var(--cor-escuro-3);
  border: 2px solid var(--cor-escuro-3);
  border-radius: 8px;
  margin: 5px 0 0 0;
  transition: all 0.3s;
}
.opcoes button:hover {
  background-color: var(--cor-escuro-2);
}
.opcoes button.ativo {
  border: 2px solid var(--cor-marca);
  pointer-events: none;
}
.opcoes button .texto {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.opcoes button .texto h3 {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
  margin: 0 0 5px 0;
}
.opcoes button .texto p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
}
.opcoes button .icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-color: var(--cor-escuro-4);
  margin: 0 10px 0 0;
}
.opcoes button .icone svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-branco);
  transform: rotate(180deg);
}
.opcoes button .foto {
  width: 55px;
  min-width: 55px;
  height: 35px;
  border-radius: 5px;
  background-size: cover;
  background-position: center;
  background-color: var(--cor-escuro-4);
  margin: 0 10px 0 0;
}
.conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% - 320px);
  padding: 30px;
}
.conteudo .parte {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  animation: fadeIn 0.3s linear;
}
.conteudo .parte .carregando {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: calc(100dvh - 100px);
  background-color: var(--cor-escuro-1);
  z-index: 3;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s;
}
.conteudo .parte .carregando.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.conteudo .parte .carregando span {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 3px solid var(--cor-marca);
  border-top: 3px solid transparent;
  animation: girando 1s linear infinite;
}
.conteudo .parte .vazio {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 80px 0;
}
.conteudo .parte .vazio svg {
  width: 100px;
  min-width: 100px;
}
.conteudo .parte .vazio h3 {
  font-family: var(--bold);
  font-size: var(--f3);
  color: var(--cor-branco);
  margin: 40px 0 10px 0;
}
.conteudo .parte .vazio p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  line-height: 1.5;
  width: 100%;
  max-width: 400px;
}
.conteudo .parte .titulo {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 0 15px 0;
}
.conteudo .parte .titulo .foto {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--cor-escuro-3);
  margin: 0 10px 0 0;
  background-size: cover;
  background-position: center;
}
.conteudo .parte .titulo .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.conteudo .parte .titulo .nome h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.conteudo .parte .titulo .nome p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  margin: 5px 0 0 0;
}
.conteudo .parte .titulo .resetar {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-left: auto;
}
.conteudo .parte .titulo .resetar button.abrir {
  display: flex;
  align-items: center;
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: var(--cor-escuro-3);
  padding: 10px 15px;
  border-radius: 10px;
  transition: all 0.3s;
}
.conteudo .parte .titulo .resetar button.abrir:hover {
  background-color: var(--cor-escuro-4);
}
.conteudo .parte .titulo .resetar button.abrir.ativo {
  background-color: var(--cor-escuro-4);
}
.conteudo .parte .titulo .resetar button.abrir svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-branco);
  margin: 0 10px 0 0;
}
.conteudo .parte .titulo .resetar .confirmar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 45px;
  right: 0;
  padding: 15px;
  background-color: var(--cor-escuro-2);
  border: 1px solid var(--cor-escuro-4);
  border-radius: 10px;
  z-index: 2;
  width: 160px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s;
}
.conteudo .parte .titulo .resetar .confirmar.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.conteudo .parte .titulo .resetar .confirmar p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  text-align: center;
  line-height: 1.5;
  margin: 0 0 5px 0;
}
.conteudo .parte .titulo .resetar .confirmar button {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: transparent;
  padding: 5px 10px;
  border-radius: 5px;
  transition: all 0.3s;
}
.conteudo .parte .titulo .resetar .confirmar button:hover {
  opacity: 0.6;
}
.conteudo .parte .titulo .resetar .confirmar button:nth-child(2) {
  color: var(--cor-vermelho);
}
.conteudo .parte .cursos {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid var(--cor-escuro-3);
  margin: 20px 0 0 0;
  animation: fadeIn 0.3s;
}
.conteudo .parte .dados {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid var(--cor-escuro-3);
  margin: 20px 0 0 0;
  animation: fadeIn 0.3s;
}
.conteudo .parte .dados h2 {
  font-family: var(--bold);
  font-size: var(--f3);
  color: var(--cor-branco);
  margin: 10px 0 20px 0;
  width: 100%;
}
.conteudo .parte .linha {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px;
  border-radius: 10px;
  background-color: var(--cor-escuro-2);
  margin: 0 0 10px 0;
  position: relative;
}
.conteudo .parte .linha h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.conteudo .parte .linha p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-marca);
  margin-left: auto;
}
.conteudo .parte .linha svg {
  width: 15px;
  min-width: 15px;
  max-height: 15px;
  fill: var(--cor-branco);
  margin: 0 10px 0 0;
}
.conteudo .parte .linha button.editar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 10px;
  background-color: var(--cor-escuro-3);
  margin-left: auto;
  transition: all 0.3s;
}
.conteudo .parte .linha button.editar:hover {
  background-color: var(--cor-escuro-4);
}
.conteudo .parte .linha button.editar svg {
  fill: var(--cor-branco);
  margin: 0;
}
.conteudo .parte .linha button.sair svg {
  fill: var(--cor-branco-fixo);
  margin: 0;
}
.conteudo .parte .linha button.sair {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 10px;
  background-color: var(--cor-vermelho);
  margin: 0 0 0 10px;
  transition: all 0.3s;
}
.conteudo .parte .linha button.sair:hover {
  background-color: var(--cor-vermelho-escuro);
}
.conteudo .parte .linha .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.conteudo .parte .linha .nome .info {
  display: flex;
  align-items: center;
  padding: 10px 0 0 0;
}
.conteudo .parte .linha .nome .info.bloqueado svg {
  fill: var(--cor-vermelho);
}
.conteudo .parte .linha .nome .info.bloqueado p {
  color: var(--cor-vermelho);
}
.conteudo .parte .linha .nome .info svg {
  fill: var(--cor-verde);
}
.conteudo .parte .linha .nome .info p {
  color: var(--cor-verde);
}
.conteudo .parte .linha .bloquear {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  height: 100%;
  width: 100%;
  max-width: 150px;
  top: 0;
  right: 0;
  padding: 10px 10px 10px 20px;
  background-color: var(--cor-escuro-2);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 2;
  transition: all 0.3s;
}
.conteudo .parte .linha .bloquear.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.conteudo .parte .linha .bloquear h3 {
  width: 100%;
  margin: 0;
  padding: 0;
  text-align: right;
}
.conteudo .parte .linha .bloquear button.sim {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-vermelho);
  background-color: transparent;
  padding: 0 5px;
  margin: 0 5px 0 10px;
  transition: all 0.3s;
}
.conteudo .parte .linha .bloquear button.nao {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: transparent;
  padding: 0 5px;
  transition: all 0.3s;
}
.conteudo .parte .linha .bloquear button:hover {
  opacity: 0.6;
}
.conteudo .parte .linha .liberar {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  background-color: var(--cor-escuro-2);
  padding: 5px 10px 5px 20px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 2;
  transition: all 0.3s;
}
.conteudo .parte .linha .liberar.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.conteudo .parte .linha .liberar .info {
  display: flex;
  align-items: center;
}
.conteudo .parte .linha .liberar .botoes {
  display: flex;
  align-items: center;
  margin: 5px 0 0 0;
}
.conteudo .parte .linha .liberar h3 {
  margin: 0 5px 0 0;
}
.conteudo .parte .linha .liberar input {
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 100px;
  border-radius: 5px;
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: var(--cor-escuro-3);
  border: none;
}
.conteudo .parte .linha .liberar input:focus {
  background-color: var(--cor-escuro-4);
}
.conteudo .parte .linha .liberar button.sim {
  font-family: var(--bold);
  font-size: var(--f1);
  color: var(--cor-verde);
  background-color: transparent;
  padding: 5px;
  margin: 0 10px 0 20px;
  transition: all 0.3s;
}
.conteudo .parte .linha .liberar button.nao {
  font-family: var(--bold);
  font-size: var(--f1);
  color: var(--cor-branco);
  background-color: transparent;
  padding: 5px;
  transition: all 0.3s;
}
.conteudo .parte .linha .liberar button:hover {
  opacity: 0.6;
}
/* Responsivo */
@media screen and (max-width: 1000px) {
  .opcoes {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    position: fixed;
    overflow-y: scroll;
    top: -60px;
    left: 0;
    width: 100%;
    height: 60px;
    max-height: 60px;
    border-right: none;
    padding: 0 15px;
    border-bottom: 2px solid var(--cor-escuro-3);
    scrollbar-width: none;
    z-index: 2;
  }
  section.configurar.mostrar .opcoes {
    top: 60px;
  }
  .opcoes::-webkit-scrollbar {
    display: none;
  }
  .opcoes h3 {
    display: none;
  }
  .opcoes button {
    width: fit-content;
    min-width: fit-content;
    padding: 10px;
    margin: 0 5px 0 0;
  }
  .conteudo {
    width: 100%;
    padding: 80px 15px 15px 15px;
  }
  .conteudo .parte {
    padding: 15px;
  }
  .conteudo .parte .tema .imagem span {
    top: 2px;
    left: 5px;
    width: calc(100% - 10px);
    height: 35px;
    border-radius: 15px 15px 0 0;
  }
}
</style>
